import modalSignup from '~/mixins/modalSignup.js'
import stripe from '~/mixins/stripe.js'
import signupIframe from '~/components/Molecules/OrganicSquad/SignupIframe/SignupIframe.vue'

export default {
  mixins: [modalSignup, stripe],

  props: {
    title: {
      type: String,
    },
    button: {
      type: Object,
    },
    video: {
      type: Object,
    },
    content: {
      type: Object,
    },
    secondContent: {
      type: Object,
    },
    logo: {
      type: Object,
    },
    sparkle: {
      type: Boolean,
      default: false,
    },
    background: {
      type: Object,
    },
    link: {
      type: Object,
    },
  },

  components: {
    signupIframe,
  },

  computed: {
    isSparkle() {
      return this.sparkle
    },

    isPricing() {
      const regex = /pricing/gi

      return Boolean(regex.test(this.$route.path))
    },
  },
}
